export const modals = {
    namespaced: true,

    state: {
        showColaborators: false,
        showConventions: false
    },

    mutations: {
        Change_State_Conventions(state) {
            state.showConventions = !state.showConventions;
        },

        Change_State_Colaborators(state) {
            state.showColaborators = !state.showColaborators;
        }
    }
}